Vue.mixin({
  methods: {
    screenTracking(screen) {
      this.$gtag.screenview({
        'dimension1': this.$store.state.auth.doctorInfo.medical_department,
        'dimension2': this.$store.state.auth.token ? 'Login' : 'Non-login',
        'dimension3': this.$store.state.auth.doctorInfo.test_flg ? 'Test' : '',
        screen_name: screen,
        app_name: process.env.MIX_ANALYTICS_APP_NAME
      })
    },
    eventTracking(event) {
      this.$gtag.event('Tap', {
        'event_category': event.event_category,
        'event_label': event.event_label,
        'dimension1': this.$store.state.auth.doctorInfo.medical_department,
        'dimension2': this.$store.state.auth.token ? 'Login' : 'Non-login',
        'dimension3': this.$store.state.auth.doctorInfo.test_flg ? 'Test' : ''
      })
    },
    surveyTracking(screen, url) {
      this.$gtag.screenview({
        '医師ID': this.$store.state.auth.doctorInfo.id,
        'URL': url,
        screen_name: screen,
        app_name: process.env.MIX_ANALYTICS_APP_NAME
      })
    },
    bannerTracking(url) {
      this.$gtag.event('buuner', {
        '医師ID': this.$store.state.auth.doctorInfo.id,
        'URL': url,
      })
    },
  }
})